// extracted by mini-css-extract-plugin
module.exports = {"roomNumber":"components_roomNumber__2v7f2","address":"components_address__WtXX_","date":"components_date__3D0vY","danger":"components_danger__1P8hc"};